(function () {
  const menu = document.querySelector("[data-menu]");
  document.querySelector("[data-menu-open]")?.addEventListener("click", () => {
    menu?.classList.add("is-open");
    menu?.removeAttribute("hidden");
  });
  document.querySelector("[data-menu-close]")?.addEventListener("click", () => {
    menu?.classList.remove("is-open");
    menu?.setAttribute("hidden", "");
  });

  const gallery = document.querySelector("[data-gallery]");
  const main = document.querySelector("[data-main]");
  let srcs = [];
  let i = 0;
  if (gallery) {
    const thumbs = [...gallery.querySelectorAll("[data-thumb]")];
    srcs = thumbs.map((t) => t.getAttribute("data-src")).filter(Boolean);
    i = Math.max(0, thumbs.findIndex((t) => t.getAttribute("aria-current") === "true"));
    const set = (n) => {
      if (!srcs.length) return;
      i = (n + srcs.length) % srcs.length;
      if (main && srcs[i]) main.src = srcs[i];
      thumbs.forEach((t, idx) => {
        if (idx === i) t.setAttribute("aria-current", "true");
        else t.removeAttribute("aria-current");
      });
    };
    thumbs.forEach((t, idx) => t.addEventListener("click", () => set(idx)));
    const box = document.querySelector("[data-lightbox]");
    const boxImg = box?.querySelector("[data-lightbox-img]");
    const openBox = () => {
      const src = srcs[i] || main?.getAttribute("src");
      if (!box || !boxImg || !src) return;
      boxImg.src = src;
      box.classList.add("is-open");
      box.removeAttribute("hidden");
    };
    const closeBox = () => {
      box?.classList.remove("is-open");
      box?.setAttribute("hidden", "");
    };
    gallery.querySelector("[data-zoom]")?.addEventListener("click", openBox);
    box?.querySelector("[data-lightbox-close]")?.addEventListener("click", closeBox);
    box?.querySelector("[data-lightbox-prev]")?.addEventListener("click", () => {
      set(i - 1);
      if (boxImg && srcs[i]) boxImg.src = srcs[i];
    });
    box?.querySelector("[data-lightbox-next]")?.addEventListener("click", () => {
      set(i + 1);
      if (boxImg && srcs[i]) boxImg.src = srcs[i];
    });
    document.addEventListener("keydown", (e) => {
      if (!box || box.hasAttribute("hidden")) return;
      if (e.key === "Escape") closeBox();
      if (e.key === "ArrowLeft") {
        set(i - 1);
        if (boxImg && srcs[i]) boxImg.src = srcs[i];
      }
      if (e.key === "ArrowRight") {
        set(i + 1);
        if (boxImg && srcs[i]) boxImg.src = srcs[i];
      }
    });
    window.__pdpSetImage = (url) => {
      if (!url || !main) return;
      main.src = url;
      const idx = srcs.indexOf(url);
      if (idx >= 0) {
        i = idx;
        thumbs.forEach((t, n) => {
          if (n === idx) t.setAttribute("aria-current", "true");
          else t.removeAttribute("aria-current");
        });
      }
    };
  }

  const jsonEl = document.querySelector("[data-product-json]");
  const select = document.querySelector("[data-variant-select]");
  const idInput = document.querySelector("[data-variant-id]");
  const add = document.querySelector("[data-add]");
  const priceNow = document.querySelector("[data-price-now]");
  const chips = [...document.querySelectorAll("[data-option-btn]")];
  if (jsonEl && (select || idInput)) {
    let product = {};
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { product = { variants: [] }; }
    const variants = product.variants || [];
    const selected = [];
    chips.forEach((btn) => {
      const idx = Number(btn.getAttribute("data-index"));
      if (btn.classList.contains("is-on")) selected[idx] = btn.getAttribute("data-value");
    });
    const findVariant = (opts) =>
      variants.find((v) => opts.every((val, idx) => !val || v.options[idx] === val));
    const apply = (variant) => {
      if (!variant) return;
      if (select) select.value = String(variant.id);
      if (idInput) {
        idInput.value = String(variant.id);
        idInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
      const opt = select?.selectedOptions?.[0];
      if (priceNow && opt?.dataset.price) priceNow.textContent = opt.dataset.price;
      if (opt?.dataset.image && window.__pdpSetImage) window.__pdpSetImage(opt.dataset.image);
      if (add) {
        add.disabled = !variant.available;
        const gb = document.querySelector(".pdp__gb");
        add.textContent = variant.available ? (gb ? "Reserve kit" : "Add to cart") : "Sold out";
      }
    };
    chips.forEach((btn) => {
      btn.addEventListener("click", () => {
        const idx = Number(btn.getAttribute("data-index"));
        selected[idx] = btn.getAttribute("data-value");
        chips.filter((c) => Number(c.getAttribute("data-index")) === idx)
          .forEach((c) => c.classList.toggle("is-on", c === btn));
        apply(findVariant(selected) || variants.find((v) => v.options[idx] === selected[idx]));
      });
    });
  }

  const qtyInput = document.querySelector("[data-qty-input]");
  document.querySelectorAll("[data-qty]").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (!qtyInput) return;
      qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) + Number(btn.getAttribute("data-qty"))));
    });
  });

  function parseEnd(value) {
    if (!value) return NaN;
    const trimmed = String(value).trim();
    const direct = Date.parse(trimmed);
    if (!Number.isNaN(direct)) return direct;
    const m = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return Date.parse(`${m[1]}-${m[2]}-${m[3]}T00:00:00+08:00`);
    return Date.parse(trimmed.replace(/(\d+)(st|nd|rd|th)/i, "$1"));
  }

  function renderCountdown(el, end) {
    const ms = end - Date.now();
    if (ms <= 0) {
      el.classList.add("is-done");
      el.innerHTML = "<p>Group buy is open.</p>";
      return false;
    }
    const total = Math.floor(ms / 1000);
    const parts = {
      dd: String(Math.floor(total / 86400)).padStart(2, "0"),
      hh: String(Math.floor((total % 86400) / 3600)).padStart(2, "0"),
      mm: String(Math.floor((total % 3600) / 60)).padStart(2, "0"),
      ss: String(total % 60).padStart(2, "0"),
    };
    Object.keys(parts).forEach((key) => {
      const node = el.querySelector("[data-" + key + "]");
      if (node) node.textContent = parts[key];
    });
    return true;
  }

  document.querySelectorAll("[data-countdown]").forEach((el) => {
    const end = parseEnd(el.getAttribute("data-end"));
    if (Number.isNaN(end)) {
      el.hidden = true;
      return;
    }
    if (!renderCountdown(el, end)) return;
    window.setInterval(() => renderCountdown(el, end), 1000);
  });

  function headingKey(text) {
    return (text || "").replace(/:$/, "").trim().toLowerCase();
  }

  function isHeadingNode(node) {
    if (!node || node.nodeType !== 1 || node.tagName !== "P") return false;
    const strong = node.querySelector("strong");
    if (!strong) return false;
    const all = node.textContent.replace(/\s+/g, " ").trim();
    const head = strong.textContent.replace(/\s+/g, " ").trim();
    return all === head && headingKey(head).length > 0;
  }

  function bucketFor(title) {
    const k = headingKey(title);
    if (["specifications", "specification", "pcb spec", "pcb specs", "plate", "gb details"].includes(k)) return "specs";
    if (["each kit contains", "kit contains", "what's included", "whats included", "included"].includes(k)) return "kit";
    if (["quality expectations", "group buy policies", "note"].includes(k)) return "policy";
    return "notes";
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, "\u0026amp;")
      .replace(/</g, "\u0026lt;")
      .replace(/>/g, "\u0026gt;")
      .replace(/"/g, "\u0026quot;");
  }

  function collectTexts(html) {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    const out = [];
    tmp.querySelectorAll("li").forEach((li) => {
      const t = li.textContent.replace(/\s+/g, " ").trim();
      if (t) out.push(t);
    });
    if (out.length) return out;
    tmp.querySelectorAll("p").forEach((p) => {
      p.innerHTML.split(/<br\s*\/?>/i).forEach((chunk) => {
        const el = document.createElement("div");
        el.innerHTML = chunk;
        const t = el.textContent.replace(/\s+/g, " ").trim();
        if (t) out.push(t);
      });
    });
    if (out.length) return out;
    html.split(/<br\s*\/?>/i).forEach((chunk) => {
      const el = document.createElement("div");
      el.innerHTML = chunk;
      const t = el.textContent.replace(/\s+/g, " ").trim();
      if (t) out.push(t);
    });
    return out;
  }

  function pairFromTexts(texts) {
    const rows = [];
    const rest = [];
    texts.forEach((t) => {
      const i = t.indexOf(":");
      if (i > 0 && i < 42) rows.push([t.slice(0, i).trim(), t.slice(i + 1).trim()]);
      else rest.push(t);
    });
    return { rows, rest };
  }

  function extractLinks(html) {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return [...tmp.querySelectorAll("a")].map((a) => a.outerHTML);
  }

  function buildDescription() {
    const src = document.querySelector("[data-desc]");
    if (!src) return;
    const sections = [];
    let current = { title: "", html: "" };
    const push = () => {
      if (current.html.replace(/<[^>]+>/g, "").trim() || current.title) sections.push(current);
    };
    [...src.childNodes].forEach((node) => {
      if (isHeadingNode(node)) {
        push();
        current = { title: node.textContent.replace(/\s+/g, " ").trim(), html: "" };
      } else if (node.nodeType === 1) {
        current.html += node.outerHTML;
      }
    });
    push();

    const intro = [];
    const specs = [];
    const kit = [];
    const policy = [];
    const notes = [];

    sections.forEach((sec) => {
      if (!sec.title) {
        intro.push(sec.html);
        return;
      }
      const bucket = bucketFor(sec.title);
      const texts = collectTexts(sec.html);
      if (bucket === "specs") {
        const parsed = pairFromTexts(texts);
        parsed.rows.forEach((row) => specs.push(row));
        parsed.rest.forEach((t) => intro.push("<p>" + esc(t) + "</p>"));
        const links = extractLinks(sec.html);
        if (links.length) intro.push("<p>" + links.join(" · ") + "</p>");
      } else if (bucket === "kit") {
        texts.forEach((item) => kit.push(item));
      } else if (bucket === "policy") {
        texts.forEach((item) => policy.push(item));
      } else {
        notes.push("<p><strong>" + esc(sec.title) + "</strong></p>" + sec.html);
      }
    });

    const host = document.createElement("div");
    host.className = "pdp__blocks";

    const introHtml = intro.join("");
    if (introHtml.replace(/<[^>]+>/g, "").trim()) {
      const story = document.createElement("div");
      story.className = "pdp__story rte";
      story.innerHTML = introHtml;
      host.appendChild(story);
    }

    function acc(title, inner, open) {
      if (!inner) return;
      const d = document.createElement("details");
      d.className = "pdp__acc";
      if (open) d.open = true;
      d.innerHTML = "<summary>" + title + "</summary>" + inner;
      host.appendChild(d);
    }

    if (specs.length) {
      const dl = specs.map(([k, v]) => {
        if (k) return "<div><dt>" + esc(k) + "</dt><dd>" + esc(v) + "</dd></div>";
        return "<div><dd>" + esc(v) + "</dd></div>";
      }).join("");
      acc("Specifications", '<dl class="pdp__spec">' + dl + "</dl>", true);
    }
    if (kit.length) {
      acc("In the kit", "<ul>" + kit.map((i) => "<li>" + esc(i) + "</li>").join("") + "</ul>");
    }
    if (policy.length) {
      acc("Quality & group-buy policy", "<ul>" + policy.map((i) => "<li>" + esc(i) + "</li>").join("") + "</ul>");
    }
    if (notes.length) {
      acc("Notes", '<div class="rte">' + notes.join("") + "</div>");
    }

    if (!host.childNodes.length) {
      acc("Details", '<div class="rte">' + src.innerHTML + "</div>", true);
    }
    src.replaceWith(host);
  }

  buildDescription();

  document.querySelectorAll("[data-sort]").forEach((sel) => {
    sel.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sel.value);
      window.location.assign(url.toString());
    });
  });

  const setHeaderOffset = () => {
    const group = document.querySelector(".shopify-section-group-header-group");
    const header = document.querySelector("#shopify-section-header, .shopify-section-header");
    const el = group || header;
    const h = el ? Math.round(el.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--header-offset", h + "px");
  };
  setHeaderOffset();
  window.addEventListener("resize", setHeaderOffset);

  const hero = document.querySelector("[data-hero]");
  const heroImg = hero && hero.querySelector(".hero__img");
  const heroCopy = hero && hero.querySelector(".hero__copy");
  if (hero && heroImg && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    let ticking = false;
    const onHeroScroll = () => {
      const h = hero.getBoundingClientRect().height || 1;
      const p = Math.min(1, Math.max(0, window.scrollY / h));
      heroImg.style.transform = "scale(" + (1 + p * 0.1) + ")";
      if (heroCopy) {
        heroCopy.style.opacity = String(1 - Math.min(1, p * 1.15));
        heroCopy.style.transform = "translateY(" + p * -24 + "px)";
      }
    };
    window.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        onHeroScroll();
        ticking = false;
      });
    }, { passive: true });
    onHeroScroll();
  }

  const drawer = document.querySelector("[data-cart-drawer]");
  const mask = document.querySelector("[data-cart-mask]");
  let cartState = { items: [], item_count: 0, total_price: 0, currency: (window.__kibouCart || {}).currency || "HKD" };

  function money(cents) {
    const cfg = window.__kibouCart || {};
    const value = (Number(cents) / 100).toFixed(2);
    const format = cfg.moneyFormat || "HK${{amount}}";
    if (format.indexOf("{{amount}}") !== -1) return format.split("{{amount}}").join(value);
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: cfg.currency || "HKD" }).format(Number(cents) / 100);
    } catch (e) {
      return "HK$" + value;
    }
  }

  function openCart() {
    if (!drawer || !mask) return;
    mask.hidden = false;
    drawer.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => {
      mask.classList.add("is-open");
      drawer.classList.add("is-open");
    });
    document.body.classList.add("cart-open");
    refreshCart();
  }

  function closeCart() {
    if (!drawer || !mask) return;
    mask.classList.remove("is-open");
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-open");
    window.setTimeout(() => { mask.hidden = true; }, 300);
  }

  function itemImage(item) {
    if (typeof item.image === "string" && item.image) return item.image;
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    return "";
  }

  function renderCart(cart) {
    cartState = cart || cartState;
    const n = cartState.item_count || 0;
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = String(n);
      if (n > 0) el.removeAttribute("hidden");
      else el.setAttribute("hidden", "");
    });
    const countP = document.querySelector(".cart-drawer__count");
    if (countP) countP.innerHTML = "<span data-cart-count-label>" + n + "</span> " + (n === 1 ? "item" : "items");
    const foot = document.querySelector("[data-cart-foot]");
    const body = document.querySelector("[data-cart-body]");
    const sub = document.querySelector("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cartState.total_price);
    if (foot) foot.hidden = n === 0;
    if (!body) return;
    if (!cartState.items || !cartState.items.length) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><button type="button" class="btn btn--ghost" data-cart-close>Continue shopping</button></div>';
      return;
    }
    body.innerHTML = "<ul class=\"cart-drawer__list\">" + cartState.items.map((item) => {
      const img = itemImage(item);
      const variant = item.variant_title && item.variant_title !== "Default Title" ? "<p class=\"muted\">" + esc(item.variant_title) + "</p>" : "";
      return '<li class="cart-drawer__line" data-key="' + esc(item.key) + '">' +
        '<a href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="">' : "") + "</a>" +
        "<div><div class=\"cart-drawer__row\"><div><a href=\"" + esc(item.url) + "\">" + esc(item.product_title || item.title) + "</a>" + variant + "</div>" +
        '<button type="button" class="cart-remove" data-cart-remove="' + esc(item.key) + '" aria-label="Remove">Remove</button></div>' +
        '<div class="cart-drawer__row" style="margin-top:12px"><div class="pdp__qty">' +
        '<button type="button" data-cart-change="' + esc(item.key) + '" data-qty="-1" aria-label="Decrease">−</button>' +
        "<span>" + item.quantity + "</span>" +
        '<button type="button" data-cart-change="' + esc(item.key) + '" data-qty="1" aria-label="Increase">+</button>' +
        "</div><p>" + money(item.final_line_price) + "</p></div></div></li>";
    }).join("") + "</ul>";
  }

  async function refreshCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } });
    if (!res.ok) return;
    renderCart(await res.json());
  }

  async function changeQty(key, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
    });
    if (!res.ok) return;
    renderCart(await res.json());
  }

  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest("[data-cart-open]");
    if (openBtn) {
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest("[data-cart-close]") || e.target.closest("[data-cart-mask]")) {
      e.preventDefault();
      closeCart();
      return;
    }
    const removeBtn = e.target.closest("[data-cart-remove]");
    if (removeBtn) {
      e.preventDefault();
      changeQty(removeBtn.getAttribute("data-cart-remove"), 0);
      return;
    }
    const qtyBtn = e.target.closest("[data-cart-change]");
    if (qtyBtn) {
      e.preventDefault();
      const key = qtyBtn.getAttribute("data-cart-change");
      const item = (cartState.items || []).find((i) => i.key === key);
      const line = qtyBtn.closest("[data-key]");
      const current = item ? item.quantity : Number((line && line.querySelector(".pdp__qty span") && line.querySelector(".pdp__qty span").textContent) || 1);
      changeQty(key, current + Number(qtyBtn.getAttribute("data-qty")));
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) closeCart();
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = form.querySelector("[name='add'], [data-add]");
      if (btn) btn.disabled = true;
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error("add");
        await refreshCart();
        openCart();
      } catch (err) {
        form.submit();
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });
})();


